import { render } from "./MinusRoundedIcon.vue?vue&type=template&id=74f3f33f"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__